import {
  FETCH_CUSTOMER_DETAIL_DATA_INIT,
  FETCH_CUSTOMER_DETAIL_DATA_SUCCESS,
  FETCH_CUSTOMER_DETAIL_DATA_FAIL,
} from './constants';

const fetchCustomerDetail = payload => ({
  type: FETCH_CUSTOMER_DETAIL_DATA_INIT,
  payload,
});

export const fetchCustomerDetailSuccess = data => ({
  type: FETCH_CUSTOMER_DETAIL_DATA_SUCCESS,
  payload: data,
});

export const fetchCustomerDetailFailure = error => ({
  type: FETCH_CUSTOMER_DETAIL_DATA_FAIL,
  error: error.message,
});

export { fetchCustomerDetail };
